<template>
  <footer class="footer px-4">
    <hr class="footer-divider" />
    <div class="align-items-center justify-content-lg-between">
      <div class="copyright text-center">
        <span class="footer-text">© {{ year }} SchoolDock</span>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    };
  }
};
</script>
<style scoped>
.footer {
  background: transparent;
  color: var(--app-text);
  padding-top: 0.75rem;
  padding-bottom: 1rem;
}

.footer-divider {
  border-color: var(--app-border);
  opacity: 0.8;
}

.footer-text {
  color: var(--app-muted);
  font-size: 0.9rem;
}
</style>
